<script lang="ts">
	import { t } from 'svelte-i18n';
	import type { InputSelectProps } from '@wiseed/wikit';
	import { InputSelect } from '@wiseed/wikit';

	export let props: InputSelectProps;

	$: props.searchPlaceholder = $t('forms.search');
	$: props.placeholder = props.placeholder ? props.placeholder : $t('forms.choose');
	$: props.placeholderMultiple = $t('forms.chooseMultiple');
</script>

<InputSelect bind:props on:click />
